export const getTeamImage = (logo, name) => {
  if (logo) return `${process.env.REACT_APP_STATIC_URL}${logo}`
  return `/images/teams/${name?.toLowerCase()?.replaceAll(' ', '')}.png`
}

export const getVpnImage = (logo) => {
  return `${process.env.REACT_APP_STATIC_URL}${logo}`
}